// extracted by mini-css-extract-plugin
module.exports = {"content":"ViewMore_content__5Ye__"};